import { render } from "./BusinessModelCatalogueDetail.vue?vue&type=template&id=504cc548&scoped=true&ts=true"
import script from "./BusinessModelCatalogueDetail.vue?vue&type=script&lang=ts"
export * from "./BusinessModelCatalogueDetail.vue?vue&type=script&lang=ts"

import "./BusinessModelCatalogueDetail.vue?vue&type=style&index=0&id=504cc548&lang=scss&scoped=true"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-504cc548"]])

export default __exports__